class PartDetailController {
  constructor(userProfile, $state, $scope) {
    this.userProfile = userProfile
    this.$state = $state

    $scope.$on('partPriceChanged', (event, part) => {
      this.part.UnitPrice = part.UnitPrice
    })
  }

  $onInit() {
    this.part.ImageFiles.forEach(file => {
      file.DisplayUrl = `${file.Url}?ForDownload=false`
    })
  }

  hasPermission(permission) {
    return this.userProfile.hasPermission(permission)
  }

  edit() {
    this.$state.go('^.edit', {
      partId: this.part.Id,
      part: this.part
    })
  }
}
PartDetailController.$inject = ['userProfile', '$state', '$scope']

export default PartDetailController
